import { KamOptionUi } from '@/components/Order/OrdersDetail/Filters/FilterUi';
import { SelectOptionUi } from '@/components/Select/SelectUi';
import { KamListResponse, KamResponse } from '@/data/api/model/staff/StaffDto';

export function kamListResponseToKamOptionUiList(
  input: KamListResponse
): KamOptionUi[] {
  return input.data.map((kamItemResponse) => ({
    id: kamItemResponse.id,
    name: kamItemResponse.full_name,
  }));
}

export function KamListResponseToSelectOptionListUi(
  items: KamResponse[]
): SelectOptionUi[] {
  return items.map((kam) => ({ id: kam.id, label: kam.full_name }));
}
